import { Component } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import {
  BusinessReasonCode,
  ChargeType,
  PartyDto,
  PartyService,
  RequestWholesaleSettlementCommand,
  SettlementService
} from '@app/api/dmc';
import { FormApiService } from '@app/core/services/form-api.service';
import { KeyValue } from '@shared/interfaces/key-value/key-value';
import { enumToKeyValue } from '@app/core/utils/enum-to-key-value';
import { InputGroupComponent } from '@shared/components/input/input-group/input-group.component';
import { LabelDirective } from '@shared/components/input/label/label.directive';
import { TranslatePipe } from '@ngx-translate/core';
import { InputDirective } from '@shared/components/input/input/input.directive';
import { SelectDirective } from '@shared/components/input/select/select.directive';
import { HasUnsavedChanges } from '@app/core/guards/unsaved-changes.guard';


@Component({
  selector: 'app-settlement-wholesale-request-modal',
  imports: [
    ReactiveFormsModule,
    InputGroupComponent,
    LabelDirective,
    TranslatePipe,
    InputDirective,
    SelectDirective
  ],
  templateUrl: './settlement-wholesale-request-modal.component.html',
  styleUrl: './settlement-wholesale-request-modal.component.css'
})
export class SettlementWholesaleRequestModalComponent implements HasUnsavedChanges {
  public hasUnsavedChanges(): boolean {
    return this.form.dirty;
  }

  public form: FormGroup = new FormGroup({
    businessReasonCode: new FormControl(null, [Validators.required]),
    chargeType: new FormControl(),
    chargeTypeId: new FormControl(),
    start: new FormControl(null, [Validators.required]),
    end: new FormControl(null, [Validators.required]),
    balanceSupplier: new FormControl(),
  })


  /** Enums **/
  public businessReasonCodeList: KeyValue[] = enumToKeyValue(BusinessReasonCode, { prefixValue: 'enum.settlement.businessreasoncode.', includeKeys: ['SecondSettlement', 'CorrectionSettlement'] });
  public chargeTypeList: KeyValue[] = enumToKeyValue(ChargeType, { omitKeys: ['NotSpecified'], prefixValue: 'enum.chargetype.'});
  public balanceSupplierList: KeyValue[] = [];

  private balanceSupplierCarrier: PartyDto[] = [];

  constructor(
    private readonly settlementService: SettlementService,
    private readonly partyService: PartyService,
    private readonly formApiService: FormApiService,
  ) {
    /** Populate Necessary Lists **/
    this.partyService.partyGetBalanceSuppliersGet().subscribe((data: PartyDto[]) => {
      this.balanceSupplierCarrier = data ?? [];

      this.balanceSupplierList = this.balanceSupplierCarrier.map((item: PartyDto) => ({
        key: item.identification ?? '',
        value: item.name ?? '',
      }))
    });
  }

  public submit(): void {
    this.formApiService.submit<RequestWholesaleSettlementCommand>(
      this.form,
      (data) => this.settlementService.settlementRequestAggregatedWholesalePost(data),
      {
        preprocess: (data: any) => ({
          ...data,
          balanceSupplier: this.balanceSupplierCarrier.find(
            (item: PartyDto) => item.identification === data.balanceSupplier
          ),
        }),
        closeModal: true,
        successMessage: 'settlement.wholesale.request.success',
      }
    );
  }
}
